
import 'url-polyfill';
import { beforeMagicRequest, afterMagicResponse } from './interceptors';
import { processXHR } from './tvproxy';
import { isTVPage } from './utils';


export default {
  install(Vue) {
    console.log(`register magic-ui-request interceptors: ${location.href}`);
    console.log(`isTVPage: ${isTVPage()}`);
    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$magicRequest = {
      beforeMagicRequest,
      afterMagicResponse,
    };
    if (isTVPage()) {
      processXHR();
    }
  },
};
